// import React, { useState, useEffect } from "react";
// import axios from "axios";

// function Greetings() {
//   const [type, setType] = useState("QUOTE");
//   const [title, setTitle] = useState("");
//   const [message, setMessage] = useState("");
//   const [image, setImage] = useState("");
//   const [data, setData] = useState([]);

//   const loadGreetings = async () => {
//     const res = await axios.get("http://localhost:4001/greetings");
//     setData(res.data);
//   };

//   useEffect(() => {
//     loadGreetings();
//   }, []);

//   const saveGreeting = async () => {
//     await axios.post("http://localhost:4001/greetings", { type, title, message, image });
//     setTitle(""); setMessage(""); setImage("");
//     loadGreetings();
//   };

//   const deleteGreeting = async (id) => {
//     await axios.delete(`http://localhost:4001/greetings/${id}`);
//     loadGreetings();
//   };

//   const postGreeting = async (id) => {
//     await axios.patch(`http://localhost:4001/greetings/post/${id}`);
//     loadGreetings();
//   };

//   const editGreeting = async (id) => {
//     const newTitle = prompt("Enter new title", title);
//     const newMessage = prompt("Enter new message", message);
//     const newImage = prompt("Enter new image URL", image);
//     const newType = prompt("Enter type QUOTE/FESTIVAL", type);

//     if (newTitle && newMessage && newImage && newType) {
//       await axios.put(`http://localhost:4001/greetings/${id}`, {
//         type: newType,
//         title: newTitle,
//         message: newMessage,
//         image: newImage
//       });
//       loadGreetings();
//     }
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <h2>Greetings Page</h2>

//       <select value={type} onChange={e => setType(e.target.value)}>
//         <option value="QUOTE">Quote of the Day</option>
//         <option value="FESTIVAL">Festival</option>
//       </select>

//       <br /><br />

//       <input
//         type="text"
//         placeholder="Title"
//         value={title}
//         onChange={e => setTitle(e.target.value)}
//       /><br /><br />

//       <textarea
//         placeholder="Message"
//         value={message}
//         onChange={e => setMessage(e.target.value)}
//       /><br /><br />

//       <input
//         type="text"
//         placeholder="Image URL"
//         value={image}
//         onChange={e => setImage(e.target.value)}
//       /><br /><br />

//       <button onClick={saveGreeting}>Save</button>

//       <hr />

//       {data.map(item => (
//         <div key={item.id} style={{ border: "1px solid #ccc", margin: "10px", padding: "10px" }}>
//           <h4>{item.type} - {item.title} {item.is_posted && "(Posted)"}</h4>
//           <p>{item.message}</p>
//           {item.image && <img src={item.image} width="200" alt="" />}
//           <br />
//           <button onClick={() => editGreeting(item.id)}>Edit</button>
//           <button onClick={() => deleteGreeting(item.id)}>Delete</button>
//           {!item.is_posted && <button onClick={() => postGreeting(item.id)}>Post</button>}
//         </div>
//       ))}
//     </div>
//   );
// }

// export default Greetings;



// import React, { useEffect, useState } from "react";
// import axios from "axios";

// function Greetings() {
//   const [type, setType] = useState("QUOTE");
//   const [message, setMessage] = useState("");
//   const [image, setImage] = useState("");
//   const [data, setData] = useState([]);

//   const loadData = async () => {
//     const res = await axios.get("http://localhost:4001/greetings");
//     setData(res.data);
//   };

//   useEffect(() => {
//     loadData();
//   }, []);

//   const saveGreeting = async () => {
//     await axios.post("http://localhost:4001/greetings", {
//       type,
//       message,
//       image
//     });
//     setMessage("");
//     setImage("");
//     loadData();
//   };

//   const deleteGreeting = async (id) => {
//     await axios.delete(`http://localhost:4001/greetings/${id}`);
//     loadData();
//   };

//   return (
//     <div>
//       <h2>Greetings Page</h2>

//       <select onChange={e => setType(e.target.value)}>
//         <option value="QUOTE">Quote of the Day</option>
//         <option value="FESTIVAL">Festival</option>
//       </select>

//       <br /><br />

//       <textarea
//         placeholder="Greeting text"
//         value={message}
//         onChange={e => setMessage(e.target.value)}
//       />

//       <br /><br />

//       <input
//         type="text"
//         placeholder="Image URL"
//         value={image}
//         onChange={e => setImage(e.target.value)}
//       />

//       <br /><br />

//       <button onClick={saveGreeting}>Save</button>

//       <hr />

//       {data.map(item => (
//         <div key={item.id}>
//           <h4>{item.type}</h4>
//           <p>{item.message}</p>
//           <img src={item.image} width="200" alt="" />
//           <br />
//           <button onClick={() => deleteGreeting(item.id)}>Delete</button>
//           <hr />
//         </div>
//       ))}
//     </div>
//   );
// }

// export default Greetings;



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "./Greetings.css"; // We'll create a separate CSS file

// function Greetings() {
//   const [type, setType] = useState("QUOTE");
//   const [message, setMessage] = useState("");
//   const [image, setImage] = useState("");
//   const [data, setData] = useState([]);

//   const loadData = async () => {
//     const res = await axios.get("http://localhost:4001/greetings");
//     setData(res.data);
//   };

//   useEffect(() => {
//     loadData();
//   }, []);

//   const saveGreeting = async () => {
//     if (!message || !image) return alert("Please enter message and image URL");
//     await axios.post("http://localhost:4001/greetings", {
//       type,
//       message,
//       image,
//     });
//     setMessage("");
//     setImage("");
//     loadData();
//   };

//   const deleteGreeting = async (id) => {
//     await axios.delete(`http://localhost:4001/greetings/${id}`);
//     loadData();
//   };

//   return (
//     <div className="greetings-container">
//       <h2>🎉 Greetings Board</h2>

//       <div className="create-form">
//         <select onChange={(e) => setType(e.target.value)} value={type}>
//           <option value="QUOTE">Quote of the Day</option>
//           <option value="FESTIVAL">Festival</option>
//         </select>

//         <textarea
//           placeholder="Write your greeting..."
//           value={message}
//           onChange={(e) => setMessage(e.target.value)}
//         />

//         <input
//           type="text"
//           placeholder="Image URL"
//           value={image}
//           onChange={(e) => setImage(e.target.value)}
//         />

//         <button onClick={saveGreeting}>Save Greeting</button>
//       </div>

//       <div className="greetings-grid">
//         {data.map((item) => (
//           <div key={item.id} className="greeting-card">
//             <img src={item.image} alt="Greeting" className="greeting-img" />
//             <div className="greeting-content">
//               <h4>{item.type}</h4>
//               <p>{item.message}</p>
//               <button onClick={() => deleteGreeting(item.id)}>Delete</button>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default Greetings;



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "./Greetings.css";

// function Greetings() {
//   const [type, setType] = useState("QUOTE");
//   const [message, setMessage] = useState("");
//   const [file, setFile] = useState(null);
//   const [data, setData] = useState([]);

//   const loadData = async () => {
//     const res = await axios.get("http://localhost:4001/greetings");
//     setData(res.data);
//   };

//   useEffect(() => {
//     loadData();
//   }, []);

//   const saveGreeting = async () => {
//     if (!message || !file) return alert("Please enter message and select an image");

//     const formData = new FormData();
//     formData.append("type", type);
//     formData.append("message", message);
//     formData.append("image", file);

//     await axios.post("http://localhost:4001/greetings", formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });

//     setMessage("");
//     setFile(null);
//     loadData();
//   };

//   const deleteGreeting = async (id) => {
//     await axios.delete(`http://localhost:4001/greetings/${id}`);
//     loadData();
//   };

//   return (
//     <div className="greetings-container">
//       <h2>🎉 Greetings Board</h2>

//       <div className="create-form">
//         <select onChange={(e) => setType(e.target.value)} value={type}>
//           <option value="QUOTE">Quote of the Day</option>
//           <option value="FESTIVAL">Festival</option>
//         </select>

//         <textarea
//           placeholder="Write your greeting..."
//           value={message}
//           onChange={(e) => setMessage(e.target.value)}
//         />

//         <input
//           type="file"
//           onChange={(e) => setFile(e.target.files[0])}
//           accept="image/*"
//         />

//         <button onClick={saveGreeting}>Save Greeting</button>
//       </div>

//       <div className="greetings-grid">
//         {data.map((item) => (
//           <div key={item.id} className="greeting-card">
//             <img src={`http://localhost:4001/${item.image}`} alt="Greeting" className="greeting-img" />
//             <div className="greeting-content">
//               <h4>{item.type}</h4>
//               <p>{item.message}</p>
//               <button onClick={() => deleteGreeting(item.id)}>Delete</button>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default Greetings;



import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Greetings.css";

function Greetings() {
  const [type, setType] = useState("QUOTE");
  const [message, setMessage] = useState("");
  const [url, setUrl] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [data, setData] = useState([]);
  const [editId, setEditId] = useState(null);

  const loadData = async () => {
    const res = await axios.get("https://api.propertygalleria.in/master/api/greetings");
    setData(res.data);
  };

  useEffect(() => {
    loadData();
  }, []);

  const editGreeting = (item) => {
    setEditId(item.id);
    setType(item.type);
    setMessage(item.message);
    setUrl(item.url);
    setPreview(item.profile_photo);
    setFile(null);
  };

  const saveGreeting = async () => {
    if (!message) return alert("Message is required");

    const formData = new FormData();
    formData.append("type", type);
    formData.append("message", message);  
    formData.append("url", url);  

    if (file) formData.append("profile_photo", file);
    if (!file && editId) formData.append("profile_photo", preview);

    if (editId) {
      await axios.put(
        `https://api.propertygalleria.in/master/api/greetings/${editId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
    } else {
      await axios.post(
        "https://api.propertygalleria.in/master/api/greetings",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
    }

    setEditId(null);
    setMessage("");
    setUrl("");
    setFile(null);
    setPreview("");
    loadData();
  };

  const deleteGreeting = async (id) => {
    await axios.delete(`https://api.propertygalleria.in/master/api/greetings/${id}`);
    loadData();
  };

  return (
    <div className="greetings-container">
      <h2>🎉 Greetings Board</h2>

      <div className="create-form">
        <select value={type} onChange={(e) => setType(e.target.value)}>
          <option value="QUOTE">Quote</option>
          <option value="FESTIVAL">Festival</option>
          <option value="INDUSTRY_UPDATES">INDUSTRY_UPDATES</option>
        </select>

        <textarea
          placeholder="Write greeting..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        <input
          type="file"
          accept="image/*"
          onChange={(e) => {
            setFile(e.target.files[0]);
            setPreview(URL.createObjectURL(e.target.files[0]));
          }}
        />
          <input
          type="text" 
            value={url}
               placeholder="Enter url..."
          // accept="image/*"
         onChange={(e) => setUrl(e.target.value)}
        />

        {preview && (
          <img
            src={preview}
            alt="preview"
            className="preview-img"
          />
        )}

        <button onClick={saveGreeting}>
          {editId ? "Update Greeting" : "Save Greeting"}
        </button>
      </div>

      <div className="greetings-grid">
        {data.map((item) => (
          <div key={item.id} className="greeting-card">
            <img src={item.image} alt="Greeting" />
            <h4>{item.type}</h4> 
            <p>{item.message}</p>
             <p style={{fontSize:'10px'}}>{item.url}</p>
            <div className="btns">
              <button style={{padding: '4px', borderRadius: '8px', border: 'none', cursor: 'pointer',color: '#8b306d'  }} onClick={() => editGreeting(item)}>Edit</button>
              <button style={{padding: '4px', borderRadius: '8px', border: 'none', cursor: 'pointer',color: '#8b306d'  }} onClick={() => deleteGreeting(item.id)}>Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Greetings;
